import { Base2Presenter } from "core/presenter";
import MyFinanceService from "./my-finance.service";
import { pathOr } from "ramda";

class CompanyIntegrationsMyFinancePresenter extends Base2Presenter {
  initialState() {
    const { company } = this.props;
    const { integrations } = company;
    return {
      loading: false,
      company: {
        ...company,
        integrations: {
          ...integrations,
          my_finance: {
            enabled: false,
            token: "",
            account_id: "",
            entity_id: ""
          }
        }
      },
      accounts: [],
      entities: [],
      accountName: "",
      entityName: "",
      pendingTransactionsOpen: false
    };
  }

  async onStart() {
    await this.checkIntegration();
  }

  async checkIntegration() {
    const { company } = this.props;
    const { integrations } = company;
    const { my_finance } = integrations;

    if (my_finance) {
      this.enqueue(vm => ({
        company: {
          ...vm.company,
          integrations: {
            my_finance
          }
        }
      }));
    }

    const integrationEnabled = pathOr(
      false,
      ["integrations", "my_finance", "enabled"],
      company
    );
    const hasToken = pathOr(
      false,
      ["integrations", "my_finance", "token"],
      company
    );
    this.enqueueMyFinanceField("enabled", integrationEnabled);
    if (hasToken) {
      this.enqueueMyFinanceField(
        "token",
        hasToken,
        async () => await this.getAccountName(my_finance.token)
      );
    }
  }

  async getAccountName(token) {
    this.enqueue({ loading: true });
    const result = await MyFinanceService.acquireAccounts(token);

    if (result.success) {
      const { company } = this.viewModel;
      const { integrations } = company;
      const { my_finance } = integrations;
      const { account_id } = my_finance;
      let accountName = "";

      for (let account of result.data) {
        if (account.account.id === account_id) {
          accountName = account.account.name;
        }
      }
      this.enqueue(
        { loading: false, accountName },
        async () => await this.getEntityName(token, account_id)
      );
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops",
        content:
          "Oops! Não foi possível resgatar a conta integrada. Verifique o token registrado e, caso necessário, edite os dados integração."
      });
      this.enqueue({ loading: false });
    }
  }

  async getEntityName(token, accountId) {
    this.enqueue({ loading: true });
    const result = await MyFinanceService.acquireEntities(token, accountId);

    if (result.success) {
      const { company } = this.viewModel;
      const { integrations } = company;
      const { my_finance } = integrations;
      const { entity_id } = my_finance;
      let entityName = "";

      for (let entity of result.data) {
        if (entity.entity.id === parseInt(entity_id, 10)) {
          entityName = entity.entity.name;
        }
      }
      this.enqueue({ loading: false, entityName });
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops",
        content:
          "Oops! Não foi possível resgatar a entidade integrada. Verifique o token e conta registrados e, caso necessário, edite os dados da integração."
      });
      this.enqueue({ loading: false });
    }
  }

  enqueueMyFinanceField(field, value, callback = () => {}) {
    this.enqueue(
      vm => ({
        company: {
          ...vm.company,
          integrations: {
            ...vm.company.integrations,
            my_finance: {
              ...vm.company.integrations.my_finance,
              [field]: value
            }
          }
        }
      }),
      () => callback()
    );
  }

  onPendingTransactionsOpen() {
    this.enqueue({ pendingTransactionsOpen: true });
  }

  onPendingTransactionsClose() {
    this.enqueue({ pendingTransactionsOpen: false });
  }
}

export default CompanyIntegrationsMyFinancePresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/view/integrations/my-finance/presenter.js